import { focusTopics } from "../data";

export default function FocusTopics() {
  return (
    <section id="focus" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-primary-600 font-semibold tracking-wide text-sm">TOPICS · 六大聚焦议题</p>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
            搭讪视频争议，都绕不开这些题
          </h2>
          <p className="mt-3 text-foreground-600 leading-7">
            我们把街头搭讪实拍争议拆解成六个可深挖的议题档案，点进任一栏目都能持续追踪该方向的新进展与新讨论。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {focusTopics.map((t, i) => {
            const isPrimary = t.color === "primary";
            return (
              <article
                key={t.title}
                className={`group relative p-6 rounded-2xl border transition overflow-hidden ${
                  isPrimary
                    ? "bg-background-50 border-primary-200 hover:border-primary-300"
                    : "bg-background-50 border-accent-200 hover:border-accent-300"
                }`}
              >
                <div className="absolute -right-5 -top-5 w-20 h-20 rounded-full opacity-20 bg-accent-200 group-hover:scale-125 transition-transform duration-300"></div>
                <div className="relative">
                  <div className="flex items-center justify-between">
                    <span
                      className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl ${
                        isPrimary ? "bg-primary-500 text-background-50" : "bg-accent-500 text-background-50"
                      }`}
                    >
                      <i className={t.icon}></i>
                    </span>
                    <span className="text-xs text-foreground-400 bg-background-100 px-2.5 py-1 rounded-full">
                      {t.count}
                    </span>
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{t.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{t.desc}</p>
                  <a
                    href="#reading"
                    className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
                    aria-label={`进入议题：${t.title}`}
                  >
                    查看该议题档案 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}